module.exports = __webpack_public_path__ + "img/green_105.5526c407.png";